import { AxiosRequestConfig } from 'axios';
import {
	getLibraryDocuments,
	getPaginated,
	postAgreement,
} from '../../../services/axiosAdobe/_api';
import { POST_AGREEMENT } from '../../../services/axiosAdobe/_payloads';
import { catchAxiosError, then } from '../../../services/axios/_utility';

/**
 * Asynchronously retrieves all library document objects across all response pages.
 * @param {AxiosRequestConfig=} config nullable HTTP request configurations.
 * @returns {object[]} array of all library document objects.
 */
export const getLibraryDocumentsPaginated = async config => {
	try {
		return await getPaginated(
			getLibraryDocuments,
			'libraryDocumentList',
			null,
			config
		);
	} catch (error) {
		throw catchAxiosError(error);
	}
};

/**
 * Asynchronously posts new third-party organization creation form for server-side initiation.
 *
 * @function
 * @param {string} organizationName name of third-party organization to be created.
 * @param {number} idRequestor unique identifier of end-user raising creating of third-party organization.
 * @param {string} nameRequestor name of end-user raising creation of third-party organization.
 * @param {string} emailRequestor email of end-user raising creation of third-party organization.
 * @param {string} emailRepresentative email of third-party organization representative who will be acknowledging agreement.
 * @param {string} documentId unique identifier of document to be associated with agreement.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise} resolved promise confirming initiation creation success.
 */
export const postAgreementInitiation = async (
	organizationName,
	idRequestor,
	nameRequestor,
	emailRequestor,
	emailRepresentative,
	documentId,
	dispatch = null
) => {
	try {
		let payload = { ...POST_AGREEMENT };
		payload.externalId.id = idRequestor.toString();
		payload.name = organizationName;
		payload.mergeFieldInfo[0].defaultValue = organizationName;
		payload.participantSetsInfo[0].memberInfos[0].email =
			emailRepresentative;
		payload.ccs[0].email = emailRequestor;
		payload.fileInfos[0].libraryDocumentId = documentId;
		payload.message =
			payload.message +
			organizationName +
			' by ' +
			nameRequestor.replace(',', ', ') +
			' (' +
			emailRequestor +
			').';
		return postAgreement(payload)
			.then(response => then(response, payload => payload, dispatch))
			.catch(error => {
				throw catchAxiosError(error);
			});
	} catch (error) {
		throw error;
	}
};
